import { render, staticRenderFns } from "./ModalSelectCollection.vue?vue&type=template&id=698a5038"
import script from "./ModalSelectCollection.vue?vue&type=script&lang=js"
export * from "./ModalSelectCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports